// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Landing from "../../templates/Landing.re.mjs";
import * as JsxRuntime from "react/jsx-runtime";

import { css, cx } from '@linaria/core'
;

var heroImg = {
  src: "https://images.instapainting.com/6278f2f59f214c11b28b457d.jpg?fit=crop&crop=focalpoint&fp-z=1.15",
  alt: "Oil painting of the orange sunset on the horizon in a forest"
};

var pageTitle = "Custom Landscape Portrait Painting";

var metaDescription = "Turn your landscape, real estate, or vacation scenery photo into a personalized, handmade portrait. View thousands of examples from real customers. Ready to be shipped in about 7-10 days.\n";

var title = "Order a Personalized Oil Painting of";

var title2 = " Your Favorite Scenery";

var description = "Turn your favorite photo into a 100% handmade physical painting from a master artist in oil, watercolor, charcoal, or other mediums. Select a product, upload a photo, and we'll find the best artist to paint \"landscape paintings\" from your vacation shipped to your door in as little as 2 weeks.";

var secondaryContent = {
  title1: "Custom Landscape",
  title2: "and Scenery Paintings",
  body: "You can browse landscape painting samples from real customers and artists. Our talented artists can provide a variety of types of artwork, including oil paintings, watercolor paintings, and charcoal or pencil drawings to capture the essence and mood of your landscape photo. This is a perfect way to immortalize your vacation scenery photos, as a real estate closing gift, or a photo of your favorite inanimate object. Our artists are located all over the globe and they only use the best materials to create your custom landscape painting, so you can rest easy knowing you’ll get a breathtaking and unique hand-painted work of art instead of a digitally-made, cheap, printed alternative."
};

var mainCta = {
  text: "Upload a Photo",
  link: "/assets"
};

var altCta = {
  text: "Browse Landscapes Gallery",
  link: "/gallery/landscape-paintings"
};

var products = [
  {
    title: "Oil Painting",
    src: "https://images.instapainting.com/626dfaed8896c7266a8b458d.jpg?fp-z=1.55&fp-x=0.5&fp-y=0.5",
    imageAlt: "",
    sku: "custphotoreal",
    price: 89
  },
  {
    title: "Watercolor",
    src: "https://images.instapainting.com/6236ee3c57765d408e8b4568.jpg?fp-z=1.2&fp-y=0.55",
    imageAlt: "",
    sku: "custwatercolor",
    price: 89
  },
  {
    title: "Charcoal",
    src: "https://images.instapainting.com/5f48816d87456f87798b4589_w0.jpg?fp-z=1.15&fp-y=0.55&fp-x=0.55",
    imageAlt: "",
    sku: "custcharcoal",
    price: 89
  },
  {
    title: "Pencil Drawing",
    src: "https://images.instapainting.com/5e21286587456fea438b4584.jpg?fp-z=1.0&fp-y=0.75",
    imageAlt: "",
    sku: "custpencil",
    price: 89
  },
  {
    title: "Colored-Pencil",
    src: "https://images.instapainting.com/60fb700ce0facbdf228b4599.jpg?fp-z=1.0",
    imageAlt: "",
    sku: "custpencil",
    price: 89
  }
];

var reviews = [
  {
    name: "Jeremy Fox",
    location: "Calgary, CA",
    review: "Very happy with the finished product, great job. We hung it up in our dining room the day we received it in the mail (shipping was quick too). Thank you!",
    link: "/products/gallery/custphotoreal/586ec6be87456f00098b456e/?order=1",
    image: "https://images.instapainting.com/587c460d87456ffe3a8b4567.jpg?fit=crop&crop=focalpoint&fp-z=1.9",
    imageAlt: "Oil painting of a landscape scene with the silhouette of a couple kissing in the distance",
    date: new Date("01/17/2017")
  },
  {
    name: "Sherry Johnson",
    location: "Houston, CA",
    review: "Beautiful job. We are going to order again. Thank you.",
    link: "/products/gallery/custcoloredpencil/60d5f745522cfafb0a8b4581/?order=1",
    image: "https://images.instapainting.com/60dd16891b2cd042088b4569.jpg",
    imageAlt: "A colored pencil drawing of a street from a wide angle view",
    date: new Date("07/19/2021")
  },
  {
    name: "Neury Trinidad",
    location: "Newark, US",
    review: "Great Job!",
    link: "/products/gallery/custphotoreal/57d21a5887456f3f798b4568/?order=1",
    image: "https://images.instapainting.com/57faf75087456f2a678b4573.jpg",
    imageAlt: "This artist did a fabulous job in recreating the picture I sent. I appreciated that they communicated periodically to keep me posted as the process went along. I will be using this company in the future on my other closings!!",
    date: new Date("10/11/2016")
  }
];

var contentBlocks = [
  {
    title1: "Hand-Painted Scenery and",
    title2: "Landscape Paintings",
    body: "Landscape photos can invoke all kinds of emotions, memories, and feelings. What better way to capture the essence of a particular location than with a hand-painted work of art? With Instapainting, you can transform your landscape picture into a painting that you can hang in your home, office, or give away as a thoughtful and meaningful gift. Our artists will work directly with you to get a sense of what you want and create a custom landscape painting for you that you’ll be proud to show off or give away as a gift."
  },
  {
    title1: "From the Beach to the Mountains,",
    title2: "Capture Your Special Vacation Place on Canvas",
    body: "Do you have a special place that you like to visit with your family on vacation? Or maybe a location that brings back happy memories from your childhood? A custom landscape portrait can help you revisit those moments or even view the world and your everyday surroundings in brand new ways.\n\nWhether it’s the beach, the mountains, or a simple, everyday place that brings you joy, our talented artists can create a custom landscape portrait that displays the spirit and emotion of the place. With a beautiful commissioned one-of-a-kind landscape portrait, you might even find that the work of art can help you find inner peace, meditate, and ease any worry or anxiety you feel. Or if you pass the painting along to a friend or loved one as a gift, they may be able to experience that peace and happiness too."
  },
  {
    title1: "Turn the Seasons Into",
    title2: "a Cherished Memory",
    body: "The seasons of the year bring many different emotions and feelings with them. From the vivid colors that burst out of the ground during the spring to cool and calm snowy winter landscapes, a custom landscape portrait can capture the beauty of it all and take you back to precious memories, breathtaking views, and heartfelt moments in time.\n\nShare the joy of a season with a friend by getting them a custom landscape painting. Or enjoy the memories that come with a portrait painted from a photo of your favorite seasonal activities. However you choose to enjoy your hand-painted landscape portrait, there’s almost no way you can go wrong with a professionally painted seasonal portrait."
  },
  {
    title1: "",
    title2: "Start by Uploading Your Photos Today",
    body: "A custom landscape portrait is a one-of-a-kind gift for any occasion that can be cherished and enjoyed for years after it’s given. If you’re searching for a fun and creative gift idea, look no further than Instapainting.\n\nWhen you’re ready to commission an artist to transform your landscape picture into a painting, just select the type of portrait you want and upload your photo to get started. Once you’ve uploaded your picture, you can add specific instructions for the artist and then submit your order. Then, we’ll help you select an artist that best aligns with your stylistic preferences, project needs, and budget. Overall, your portrait should take less than three weeks’ time to complete and it will be safely and securely shipped to your home when it’s complete.\n\nThe best part? You get to review your custom landscape painting before it’s completed and shipped to you, with unlimited revisions so you can have peace of mind that your money was well spent. When you’re ready to get started, simply upload your landscape photo here on our website."
  }
];

function LandscapePaintingsPage(props) {
  return JsxRuntime.jsx(Landing.LandingPage.make, {
              pageTitle: pageTitle,
              heroImg: heroImg,
              title: title,
              title2: title2,
              description: description,
              metaDescription: metaDescription,
              secondaryContent: secondaryContent,
              mainCta: mainCta,
              altCta: altCta,
              products: products,
              reviews: reviews,
              contentBlocks: contentBlocks
            });
}

var make = LandscapePaintingsPage;

var $$default = LandscapePaintingsPage;

export {
  heroImg ,
  pageTitle ,
  metaDescription ,
  title ,
  title2 ,
  description ,
  secondaryContent ,
  mainCta ,
  altCta ,
  products ,
  reviews ,
  contentBlocks ,
  make ,
  $$default as default,
}
/*  Not a pure module */
